import { generateKebabCase } from '@nexelem/utils';
import { OrderStatus } from '@nexelem/api';
import { NavigationGroups } from '@nexelem/config';

export const ordersOutletRouteId = generateKebabCase(NavigationGroups.sales, 'orders');
export const orderDetailsRouteId = generateKebabCase(NavigationGroups.sales, 'orders', 'details');
export const orderEditRouteId = generateKebabCase(NavigationGroups.sales, 'orders', 'details', 'edit');
export const orderListRouteId = generateKebabCase(NavigationGroups.sales, 'orders', 'list');
export const orderCreateRouteId = generateKebabCase(NavigationGroups.sales, 'orders', 'create');
export const allowedStatusesForOutdated = [OrderStatus.new, OrderStatus.inProgress, OrderStatus.partiallyShipped];
export const statusesWithoutSettingBudget = [OrderStatus.deleted, OrderStatus.cancelled, OrderStatus.done];
